import { LocalStorageKey } from '../constants/localStorageKeys';
import { OpenPanelEvents } from '../constants/openPanelEvents';
import { getUser } from '../services/authService';
import { trackOpenPanel } from './openPanelHelper';
import { trackCustomerIo } from './customerIoHelper';

// Property keys (name, email, phone, survey_score, description) are pinned by
// the tech team's "Survey Submission Tracking" request — reporting depends on
// them. Keys without a value are omitted, never sent as empty strings.
const safeRead = (key) => {
	try {
		const raw = localStorage.getItem(key);
		return raw ? JSON.parse(raw) : null;
	} catch (error) {
		return null;
	}
};

const formatContactNumber = (contactNumber) => {
	if (!contactNumber) {
		return null;
	}
	if (typeof contactNumber === 'string') {
		return contactNumber;
	}
	if (contactNumber.code && contactNumber.number) {
		return `+${contactNumber.code} ${contactNumber.number}`;
	}
	return null;
};

export const trackSurveySubmitted = (rating, suggestion) => {
	try {
		const personalInformation = safeRead(LocalStorageKey.userPersonalInfo);

		let email = null;
		try {
			email = getUser()?.email || null;
		} catch (error) {
			email = null;
		}

		const name = personalInformation?.firstName || null;
		const phone =
			formatContactNumber(personalInformation?.contactNumber) ||
			formatContactNumber(safeRead(LocalStorageKey.userContactNumber));
		const description = typeof suggestion === 'string' ? suggestion.trim() : '';

		const properties = {
			...(name ? { name } : {}),
			...(email ? { email } : {}),
			...(phone ? { phone } : {}),
			survey_score: Number(rating),
			...(description ? { description } : {}),
		};

		trackOpenPanel(OpenPanelEvents.surveySubmitted, properties);
		trackCustomerIo(OpenPanelEvents.surveySubmitted, properties);
	} catch (error) {
		console.warn('OpenPanel survey tracking failed.', error);
	}
};
